import { SimulateResults } from "@keita/lanepatrol-sdk";
import { SimulatedResult } from "../../project/models/ForecastScenario";
import {
  jwtAuthAxios,
  optionalAuthAxios,
} from "../../shared/utils/network-utils";
import {
  OsaNodeCoding,
  CreateOrUpdateOsaNodeCoding,
} from "../models/OsaNodeCoding";

export const OsaNodeCodingApi = {
  batchUpdate: async (codingEntries: CreateOrUpdateOsaNodeCoding[]) => {
    return await jwtAuthAxios().put<OsaNodeCoding[]>(
      `/osa-node-coding`,
      codingEntries
    );
  },

  simulateResults: async (body: SimulateResults) => {
    return await optionalAuthAxios().post<SimulatedResult[]>(
      `/osa-node-coding/simulate-results`,
      body
    );
  },
};
